import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeClosed = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 0H24V24H0V0Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1 12C2.79531 16.1107 7.04428 19 12 19C16.9557 19 21.2047 16.1107 23 12",
				stroke: "#444444",
				strokeWidth: 2,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 20.7071,
				y: 15.4142,
				width: 1,
				height: 3,
				rx: .5,
				transform: "rotate(-45 20.7071 15.4142)",
				fill: "#444444",
				stroke: "#444444"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: -.707107,
				width: 1,
				height: 3,
				rx: .5,
				transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 3.03557 14.9142)",
				fill: "#444444",
				stroke: "#444444"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: -.640856,
				y: .298836,
				width: 1,
				height: 2.66544,
				rx: .5,
				transform: "matrix(-0.939693 -0.34202 -0.34202 0.939693 8.60377 18.3828)",
				fill: "#444444",
				stroke: "#444444"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 16.492,
				y: 21.0454,
				width: 1,
				height: 2.66544,
				rx: .5,
				transform: "rotate(160 16.492 21.0454)",
				fill: "#444444",
				stroke: "#444444"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 0H24V24H0V0Z",
			fill: "white"
		})
	}) })]
});
export default SvgEyeClosed;
